const state = {
  notificationModalQueue: [],
}
const mutations = {
  ADD_MODAL_COMPONENT_TO_QUEUE: (state, { component, componentProps }) => {
    state.notificationModalQueue.push({ component, componentProps })
  },
  POP_ACTIVE_MODAL_FROM_QUEUE: (state) => {
    state.notificationModalQueue.shift()
  },
}
const actions = {
  addModalToQueue: ({ commit }, { component, componentProps }) => {
    commit("ADD_MODAL_COMPONENT_TO_QUEUE", { component, componentProps })
  },
  popActiveModalFromQueue: ({ commit }) => {
    commit("POP_ACTIVE_MODAL_FROM_QUEUE")
  },
}
const getters = {
  activeModal: state => state.notificationModalQueue[0] || null,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/notifications/notifications.module.js